module.exports = __webpack_public_path__ + "img/play.8e7cffb6.png";